// extracted by mini-css-extract-plugin
module.exports = {"root":"TextLoader_root__d9s0P","react-loading-skeleton":"TextLoader_react-loading-skeleton__S_rde"};